<section class="case-list-page">

  <!-- Main heading (screen reader only) -->
  <h1 class="sr-only">Case List</h1>
  
  <form [formGroup]="filterForm" (ngSubmit)="applySelection()"
   aria-label="Filter Cases Form">
    <div class="filter-container">
      <div class="search-container">
        <div class="search-bar">
          <i class="fa-solid fa-magnifying-glass search-icon" 
          aria-hidden="true"></i>
          <input
            type="search"
            formControlName="searchText"
            placeholder="Search applicants"
            aria-label="Search applicants"
            (input)="onSearchInput()"
          />
          <button
            *ngIf="filterForm.get('searchText')?.value"
            class="clear-btn"
            (click)="clearSearch()"
            type="button"
            aria-label="Clear search"
          >
            <i class="fa-solid fa-circle-xmark"  aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div>
        <!--Mat Time Remaining Dropdown -->
        <div class="dropdown custom-dropdown">
          <button
            class="time-remaining-dropdown-button"
            mat-button
            type="button"
            [disabled]="currentTabStatusType === 'APPROVED' || currentTabStatusType === 'DENIED'"
            (click)="toggleDropdown()"
            [attr.aria-expanded]="isDropdownOpen"
            aria-controls="timeRemainingDropdownContent"
          >
            <span
              class="time-remaining-title"
              *ngIf="
              !filterForm.get('minRemainingDays')?.value && 
              !filterForm.get('maxRemainingDays')?.value
              "
            >
              Time Remaining
            </span>
            <span class="time-remaining-title"
              *ngIf="
              filterForm.get('minRemainingDays')?.value || 
              filterForm.get('maxRemainingDays')?.value
              "
            >
              {{
                filterForm.get('minRemainingDays')?.value && !filterForm.get('maxRemainingDays')?.value
                  ? 'Starting from ' + filterForm.get('minRemainingDays')?.value
                  : filterForm.get('maxRemainingDays')?.value && !filterForm.get('minRemainingDays')?.value
                  ? 'Up to ' + filterForm.get('maxRemainingDays')?.value
                  : filterForm.get('minRemainingDays')?.value && filterForm.get('maxRemainingDays')?.value
                  ? filterForm.get('minRemainingDays')?.value + ' - ' + filterForm.get('maxRemainingDays')?.value
                  : 'Time Remaining'
              }}
            </span>
            <svg
              viewBox="0 0 24 24"
              class="angle-down-icon"
              focusable="false"
              aria-hidden="true"
            >
              <path style="fill: #0000008a" d="M7 10l5 5 5-5"></path>
            </svg>
          </button>

          <div
            class="time-remaining-dropdown-content"
            *ngIf="isDropdownOpen"
            id="timeRemainingDropdownContent"
          >
            <div class="time-remaining-dropdown-label">Time Remaining</div>
            <div class="no-min-max-labels">
              <span class="no-min-max">Minimum</span>
              <span class="no-min-max">Maximum</span>
            </div>
            <div class="no-min-max-sub-dropdown-wrapper">
              <mat-form-field appearance="outline" class="no-min-max-wrapper small">
                <mat-label class="no-min-max-label">No Min</mat-label>
                <mat-select
                  panelClass="time-remaining-dropdown-panel"
                  formControlName="minRemainingDays"
                  name="minRemainingDays"
                  [(value)]="minTime"
                  aria-label="Minimum time remaining">
                  <mat-option 
                  *ngFor="let minTime of minTimeOptions" 
                  [value]="minTime"
                  >{{ minTime }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="no-min-max-wrapper small">
                <mat-label class="no-min-max-label">No Max</mat-label>
                <mat-select
                  panelClass="time-remaining-dropdown-panel"
                  formControlName="maxRemainingDays"
                  aria-label="Maximum time remaining"
                  [(value)]="maxTime">
                  <mat-option 
                  *ngFor="let maxTime of maxTimeOptions"
                   [value]="maxTime"
                   >{{ maxTime }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <button
              class="close-button"
              mat-button
              (click)="closeInnerDropdown()"
              aria-label="Close time remaining filter"
            >
              Close
            </button>
          </div>
        </div>
      </div>

      <div>
        <mat-form-field class="smaller" panelClass="last-updated-calendar" appearance="outline">
          <mat-label>Last Updated</mat-label>
          <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker" aria-label="Last updated date range">
            <input
             matStartDate 
             formControlName="start"
              placeholder="Start date"
               aria-label="Start date"
                />
            <input matEndDate formControlName="end" placeholder="End date" 
            aria-label="End date"/>
          </mat-date-range-input>
          <mat-datepicker-toggle 
          matIconSuffix 
          [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>

          @if (dateRange.get('start')?.hasError('matStartDateInvalid')) {
          <mat-error>Invalid start date</mat-error>
          } @if (dateRange.get('end')?.hasError('matEndDateInvalid')) {
          <mat-error>Invalid end date</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Completion Status Dropdown -->
      <div>
        <mat-form-field appearance="outline" class="small custom-dropdown">
          <mat-label>Completion Status</mat-label>

          <mat-select
            panelClass="completion-status-dropdown-panel"
            formControlName="completionStatus"
            multiple
            [matTooltip]="getCompletionStatusTooltip()"
            matTooltipPosition="above"
            aria-label="Select completion status"
          >
            <!-- Select All Option -->
            <div class="select-all-container">
              <mat-checkbox
                color="primary"
                class="select-all-checkbox"
                [checked]="allCompletionStatusSelected"
                (change)="toggleSelectAll('completionStatus', $event.checked)"
              >
                Select All
              </mat-checkbox>
            </div>

            <!-- Grouped Statuses -->
            <ng-container *ngFor="let group of groupedCompletionStatusOptions">
              <!-- Status Group Header (Disabled, No Checkbox) -->
              <div class="status-group-header">
                <strong class="status-group-text">{{ group.statusGroup.toUpperCase() }}</strong>
              </div>

              <!-- Statuses under the group -->
              <mat-option
              *ngFor="let status of group.statuses"
              [value]="status.id"
            >               
             {{ status.status }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Assignee Dropdown -->
      <div *ngIf="userRole === 'ADMIN'">
        <mat-form-field appearance="outline" class="small custom-dropdown">
          <mat-label>Assignee</mat-label>
          <mat-select
            formControlName="assignees"
            multiple
            panelClass="assignee-panel"
            [matTooltip]="getAssigneeTooltip()"
            matTooltipPosition="above"
            (opened)="focusAssigneeSearch()"
          >
            <!-- SEARCH BAR CONTAINER -->
            <div class="assignee-search-container">
              <i class="fa-solid fa-magnifying-glass search-icon"></i>
              <input
                matInput
                type="search"
                aria-label="Assignee Search"
                placeholder="Search"
                [formControl]="assigneeSearchCtrl"
                class="search-input"
                #assigneeSearchInput
              />
              <button
                *ngIf="assigneeSearchCtrl.value"
                class="clear-btn"
                (click)="clearAssigneeSearch()"
                type="button"
                aria-label="Clear assignee search"
              >
                <i class="fa-solid fa-circle-xmark clear-icon"></i>
              </button>
            </div>
            <!-- Select All Option -->
            <div class="select-all-container" *ngIf="!isSearchingAssignees">
              <mat-checkbox
                color="primary"
                class="select-all-checkbox"
                [checked]="allAssigneesSelected"
                (change)="toggleSelectAll('assignees', $event.checked)"
              >
                Select All
              </mat-checkbox>
            </div>
            <!-- Filtered Assignees -->
            <mat-option
              *ngFor="let assignee of filteredAssigneeOptions"
              [value]="assignee.userId"
              (click)="onOptionChange('assignees')"
            >
              {{ assignee.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Second Row: Clear Filters and Search Buttons -->
      <div>
        <button
          mat-button
          type="reset"
          class="btn custom-btn-secondary clear-filters-btn"
          (click)="clearFilters()"
          aria-label="Clear all filters"
        >
          Clear Filters
        </button>
      </div>

      <div>
        <button
          color="primary"
          type="submit"
          class="search-btn button-default custom-btn-primary "
          aria-label="Apply selected filters"
        >
          Apply Filters
        </button>
      </div>
    </div>
  </form>

  <div class="overlay" *ngIf="isLoading"></div>
  <div class="d-flex justify-content-center" *ngIf="isLoading">
    <div 
    class="spinner-border loading-indicator" 
    role="status"
     aria-live="polite">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="tabChanged($event)" [(selectedIndex)]="selectedTabIndex">
    <mat-tab>
      <ng-template mat-tab-label>
        <span style="display: flex; align-items: center; gap: 6px;">
          <span>{{ tabNames[0] }}</span>
          <span class="badge-large">{{ activeCount }}</span>
        </span>
      </ng-template>
      <section class="case-list-table-container mat-elevation-z0" *ngIf="!isLoading" aria-live="polite">
        <h2 class="sr-only">List of Cases</h2>
        <app-eg-table
          *ngIf="caseList.length > 0"
          [data]="caseList"
          [start]="start"
          [end]="end"
          [pageSize]="pageSize"
          [totalElements]="totalElements"
          [pageIndex]="pageIndex"
          [columns]="displayedColumns"
          [columnKeyValues]="cols"
          [multiselectcheckbox]="false"
          [serverSidePagination]="true"
          (pageEvent)="getPaginatorData($event)"
          (btnClicked)="viewCase($event)"
          [showSortIcon]="true"
          [moduleName]="'case-list'"
        >
        </app-eg-table>
        <div class="no-cases" *ngIf="caseList && caseList?.length === 0">
          <p>No cases to display.</p>
        </div>
        <!-- History Offcanvas wrapped in <aside> -->
        <aside
          class="offcanvas offcanvas-end custom-offcanvas"
          tabindex="-1"
          id="offcanvasRight"
          aria-labelledby="offcanvasRightLabel"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          aria-live="polite"
        >
          <div class="offcanvas-header">
            <h2 id="offcanvasRightLabel" class="offcanvas-title font-bolder">
              History
            </h2>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              Close
            </button>
          </div>
          <div class="offcanvas-body">
            <div class="history-container" *ngIf="historyList?.length > 0">
              <div *ngFor="let history of historyList" class="history-item" tabindex="0">
                <div class="history-header">
                  <div class="history-data">
                    <time>{{ history.updatedDate }}</time> <span class="user"> {{ history.user }}</span>
                  </div>
                </div>
                <div class="content">
                  <div [innerHTML]="history.statusChanged">
                  </div>
                  <div>
                    <small> {{ history.notes }} </small>
                  </div>
                </div><br>
              </div>
              <br>
            </div>
            <div *ngIf="historyList?.length === 0">
              <p>No history available.</p>
            </div>
          </div>
        </aside>
      </section>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span style="display: flex; align-items: center; gap: 6px;">
          <span>{{ tabNames[1] }}</span>
          <span class="badge-large">{{approvedCount}}</span>
        </span>
      </ng-template>
      <section class="case-list-table-container mat-elevation-z0" *ngIf="!isLoading" aria-live="polite">
        <h2 class="sr-only">List of Cases</h2>
        <app-eg-table
          *ngIf="caseList.length > 0"
          [data]="caseList"
          [start]="start"
          [end]="end"
          [pageSize]="pageSize"
          [totalElements]="totalElements"
          [pageIndex]="pageIndex"
          [columns]="approvedDisplayColumns"
          [columnKeyValues]="approvedCols"
          [multiselectcheckbox]="false"
          [serverSidePagination]="true"
          (pageEvent)="getPaginatorData($event)"
          (btnClicked)="viewCase($event)"
          [showSortIcon]="true"
          [moduleName]="'case-list'"
          (renewalClicked)="onRenewalClicked($event)"
          (printRenewalClicked)="onPrintRenewalLetter($event)"
        >
        </app-eg-table>
        <div class="no-cases" *ngIf="caseList && caseList?.length === 0">
          <p>No cases to display.</p>
        </div>
        <!-- History Offcanvas wrapped in <aside> -->
        <aside
          class="offcanvas offcanvas-end custom-offcanvas"
          tabindex="-1"
          id="offcanvasRight"
          aria-labelledby="offcanvasRightLabel"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          aria-live="polite"
        >
          <div class="offcanvas-header">
            <h2 id="offcanvasRightLabel" class="offcanvas-title font-bolder">
              History
            </h2>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              Close
            </button>
          </div>
          <div class="offcanvas-body">
            <div class="history-container" *ngIf="historyList?.length > 0">
              <div *ngFor="let history of historyList" class="history-item" tabindex="0">
                <div class="history-header">
                  <div class="history-data">
                    <time>{{ history.updatedDate }}</time> <span class="user"> {{ history.user }}</span>
                  </div>
                </div>
                <div class="content">
                  <div [innerHTML]="history.statusChanged">
                  </div>
                  <div>
                    <small> {{ history.notes }} </small>
                  </div>
                </div><br>
              </div>
              <br>
            </div>
            <div *ngIf="historyList?.length === 0">
              <p>No history available.</p>
            </div>
          </div>
        </aside>
      </section>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span style="display: flex; align-items: center; gap: 6px;">
          <span>{{ tabNames[2] }}</span>
          <span class="badge-large">{{ deniedCount }}</span>
        </span>
      </ng-template>
      <section class="case-list-table-container mat-elevation-z0" *ngIf="!isLoading" aria-live="polite">
        <h2 class="sr-only">List of Cases</h2>

        <app-eg-table
          *ngIf="caseList.length > 0"
          [data]="caseList"
          [start]="start"
          [end]="end"
          [pageSize]="pageSize"
          [totalElements]="totalElements"
          [pageIndex]="pageIndex"
          [columns]="displayedColumns"
          [columnKeyValues]="cols"
          [multiselectcheckbox]="false"
          [serverSidePagination]="true"
          (pageEvent)="getPaginatorData($event)"
          (btnClicked)="viewCase($event)"
          [showSortIcon]="true"
          [moduleName]="'case-list'"
        >
        </app-eg-table>
        <div class="no-cases" *ngIf="caseList && caseList?.length === 0">
          <p>No cases to display.</p>
        </div>
        <!-- History Offcanvas wrapped in <aside> -->
        <aside
          class="offcanvas offcanvas-end custom-offcanvas"
          tabindex="-1"
          id="offcanvasRight"
          aria-labelledby="offcanvasRightLabel"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          aria-live="polite"
        >
          <div class="offcanvas-header">
            <h2 id="offcanvasRightLabel" class="offcanvas-title font-bolder">
              History
            </h2>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              Close
            </button>
          </div>
          <div class="offcanvas-body">
            <div class="history-container" *ngIf="historyList?.length > 0">
              <div *ngFor="let history of historyList" class="history-item" tabindex="0">
                <div class="history-header">
                  <div class="history-data">
                    <time>{{ history.updatedDate }}</time> <span class="user"> {{ history.user }}</span>
                  </div>
                </div>
                <div class="content">
                  <div [innerHTML]="history.statusChanged">
                  </div>
                  <div>
                    <small> {{ history.notes }} </small>
                  </div>
                </div><br>
              </div>
              <br>
            </div>
            <div *ngIf="historyList?.length === 0">
              <p>No history available.</p>
            </div>
          </div>
        </aside>
      </section>
    </mat-tab>
  </mat-tab-group>
</section>
